import React from 'react';
import PropTypes from 'prop-types';
// routes
import RoutesTester from '../tester/routes';
import RoutesCompany from '../company/routes';
import RoutesAdmin from '../admin/routes';
import { config } from '../config';

const loginType = config.REACT_APP_PLATFORM_TYPE;

export function RouteSelected({ history }) {
  switch (loginType) {
    case 'tester':
      return <RoutesTester history={history} />;
    case 'company':
      return <RoutesCompany history={history} />;
    case 'admin':
      return <RoutesAdmin history={history} />;
    default:
      return null;
  }
}

RouteSelected.propTypes = {
  history: PropTypes.object.isRequired,
};
